import { ProblematicMetadataRow } from '../../../core/models/api.models';
import { formatNumericList } from './metadata-inspection.utils';

export function countDistinctMetadataIds(rows: Array<Pick<ProblematicMetadataRow, 'metadataId'>>): number {
  return new Set(rows.map(row => row.metadataId)).size;
}

export function formatAtlasPersonnePhysiqueIds(ids: number[]): string {
  return formatNumericList(ids);
}

export function formatAtlasGerePar(gerePar: number | null | undefined): string {
  switch (gerePar) {
    case 10:
      return 'Ariane';
    case 20:
    case 21:
      return 'Minotaure';
    case null:
    case undefined:
      return 'Indisponible';
    default:
      return `Inconnu (${gerePar})`;
  }
}
